import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";
import { TipoMovimentacao ,initialValueTipoMovState, TipoMovState, TipoMovActions, tipoMovsDefault } from "./tipomov.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { ItemActions } from "../item/item.model";
import { itemController } from "../item/item.controll";

export interface TipoMovViewProps{
    tipoMovState:TipoMovState
    tipoMovActions:TipoMovActions
    itemActions:ItemActions
}

class TipoMovController extends Controller<TipoMovimentacao, TipoMovState, TipoMovActions> {
    constructor() {
        super(initialValueTipoMovState.row.type,initialValueTipoMovState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            startDocTipoMov: `@${this.moduloName}/START_DOC_TIPO_MOV`,
            setTabValue : `@${this.moduloName}/SET_TAB_VALUE`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            startDocTipoMov:()=>action(this.actionsType.startDocTipoMov, {this:this}),
            setTabValue:(value)=>action(this.actionsType.setTabValue,{value,this:this})
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.startDocTipoMov,this.startDocTipoMovEffects),
            takeLatest(this.actionsType.setTabValue,this.setTabValueEffect),
        ]
    }


    private* startDocTipoMovEffects(actions:Payload){
        let vm = actions.payload.this as Controller<TipoMovimentacao, TipoMovState, TipoMovActions>
        try {
            let resp:ResultDb<TipoMovimentacao> = yield call(vm.read)
            if(resp.status === "ok" && resp.rows?.length === 0){
                //primeira inicializacao, adicionar os tiposMov 
                console.log("tipoMovsDefault", tipoMovsDefault);
                let respAddAll:ResultDb<TipoMovimentacao> = yield call(vm.db.salveAll,tipoMovsDefault)
                if(respAddAll.status === "ok"){
                    yield put(vm.reducer.resultAfterEffects(
                        {...vm.state,loading:false,msg:respAddAll.msg as string,rows:respAddAll.rows!,status:respAddAll.status,changeList:new Date().toISOString()},
                        vm.actionsType.read
                    ))                    
                } else {
                    console.log("error saveAll tipoMovsDefault",respAddAll.msg);
                }
            } else if(resp.status === "ok" && resp.rows && resp.rows.length > 0 ){
                yield put(vm.reducer.resultAfterEffects(
                    {...vm.state,loading:false,msg:resp.msg as string,rows:resp.rows,status:resp.status,changeList:new Date().toISOString()},
                    vm.actionsType.read
                ))                    
            }
         
        } catch (error:any) {
            console.log("error startDocTipoMovEffects",error);
            let msg = "Ops, ocorreu uma falha em startDocTipoMovEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error 
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state,loading:false,msg:err,status:"error",error:true,showAlert:true},
                vm.actionsType.startDocTipoMov
            )) 
        }
    }

    private* setTabValueEffect(actions:Payload){
        let vm = actions.payload.this as Controller<TipoMovimentacao, TipoMovState, TipoMovActions>
        yield put(vm.reducer.resultAfterEffects(
            {...vm.state, tabValue:actions.payload.value},
            vm.actionsType.setTabValue
        )) 
    }

}

export const tipoMovController = new TipoMovController()

export const mapStateToTipoMovProps = (state: ApplicationState) => ({
    tipoMovState: state.tipoMovState,
})

export const mapDispatchToTipoMovProps = (dispatch: Dispatch) => ({
    tipoMovActions: bindActionCreators({...tipoMovController.reducer.actions}, dispatch),
    itemActions: bindActionCreators({...itemController.reducer.actions}, dispatch),
})